<template>
  <div class="tenants-index-view">
    <h1>{{$t('titles.productCategories')}}</h1>

    <search-input ref="search" v-model="searchQuery" />

    <data-grid
      v-if="gridLoaded"
      :columns="gridColumns"
      :sortable="['name']"
      :rows="tenants.entries"
      :sort-info="tenants.sort"
      :page-info="tenants.pagination"
      :show-actions="false"
      :is-loading="isLoading"
      class="uk-margin-medium"
      @sort="sortBy"
    >
      <span slot="empty">{{$t('hints.empty')}}</span>
      <template slot="row" scope="props">
        <td>
          <router-link
            :to="{ name: 'product-categories-for-tenant', params: { tenantId: props.row.id } }"
          >
            {{props.row.name}}
          </router-link>
        </td>
      </template>
    </data-grid>

    <div
      v-else
      class="loader-container uk-container uk-margin-medium-top uk-text-center"
    >
      <loader />
    </div>
  </div>
</template>

<script>
import IndexView from '@/mixins/IndexView';
import tenantsQuery from '@/api/queries/tenants.graphql';

export default {
  name: 'product-categories-index-view',
  mixins: [
    IndexView('tenants', {
      gridFields: ['name'],
      listQuery: tenantsQuery,
      nameField: 'name',
    }),
  ],
  i18n: {
    messages: {
      de: {
        titles: {
          productCategories: 'Produktkategorien',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// IndexView.vue?f6535c7e